(() => {
  const initialise = (root = document) => {
    const requestedModel = new URLSearchParams(window.location.search).get('model');
    root.querySelectorAll('[data-gl-model]').forEach(input => {
      if (!input.value && requestedModel) input.value = requestedModel.slice(0, 300);
    });
    root.querySelectorAll('[data-gl-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      gallery.addEventListener('click', event => {
        const thumbnail = event.target.closest('[data-gl-thumbnail]');
        if (!thumbnail || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const mainImage = gallery.querySelector('.gl-main-image');
        const mainLink = gallery.querySelector('[data-gl-main-link]');
        if (!mainImage || !mainLink) return;
        event.preventDefault();
        mainImage.src = thumbnail.dataset.glSrc;
        mainImage.removeAttribute('srcset');
        mainLink.href = thumbnail.href;
        gallery.querySelectorAll('[data-gl-thumbnail]').forEach(link => link.removeAttribute('aria-current'));
        thumbnail.setAttribute('aria-current', 'true');
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.gl-mobile-nav[open]').forEach(menu => { menu.open = false; menu.querySelector('summary').focus(); });
  });
  document.addEventListener('click', event => {
    const menu = document.querySelector('.gl-mobile-nav[open]');
    if (menu && (!menu.contains(event.target) || event.target.closest('a'))) menu.open = false;
  });
})();
